export const environment = {
  production: true,
  apiBaseUrl: 'https://app-jstyle-ryugaku-prod-001.azurewebsites.net/',
  iconBaseUrl: 'https://stjstyleryugakuprod001.z11.web.core.windows.net/'
};
